var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wrapper" }, [
    _c(
      "span",
      { staticStyle: { display: "inline-block", "min-width": "125px" } },
      [_vm._v(_vm._s(_vm.phoneNumber))]
    ),
    _c("span", { domProps: { innerHTML: _vm._s(_vm.flag) } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }